import { defineNuxtRouteMiddleware, navigateTo } from "#app";
import { USER_CENTER_BASE_PATH, stripUserCenterBase } from "~/user-center/routes";
import { getToken, setToken } from "~/user-center/src/utils/auth";
import { setMallAppToken } from "~/utils/globalData";

export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    return;
  }

  if (!to.path.startsWith(USER_CENTER_BASE_PATH)) {
    return;
  }

  const nextJyToken = typeof to.query.setJyToken === "string"
    ? to.query.setJyToken
    : Array.isArray(to.query.setJyToken)
      ? to.query.setJyToken[0]
      : "";
  const nextMallToken = typeof to.query.setMallToken === "string"
    ? to.query.setMallToken
    : Array.isArray(to.query.setMallToken)
      ? to.query.setMallToken[0]
      : "";

  if (nextJyToken) {
    setToken(nextJyToken);
  }

  if (nextMallToken) {
    setMallAppToken(nextMallToken);
  }

  const hasToken = Boolean(getToken());
  const requiresAuth = to.meta.requiresUserCenterAuth !== false;

  if (!hasToken && requiresAuth) {
    const redirect = stripUserCenterBase(to.fullPath) || "/mall/home";
    return navigateTo(
      `${USER_CENTER_BASE_PATH}/login?redirect=${encodeURIComponent(redirect)}`,
      { replace: true },
    );
  }

  if (hasToken && to.path === `${USER_CENTER_BASE_PATH}/login`) {
    return navigateTo(`${USER_CENTER_BASE_PATH}/mall/home`, { replace: true });
  }
});
